import { DialogPlugin } from 'tdesign-vue-next'

type SmartConfirmOptions = Record<string, unknown>
type SmartConfirmInstance = {
  onConfirm: (handler: () => unknown | Promise<unknown>) => unknown
  destroy: () => unknown
}

const dialogPlugin = DialogPlugin as unknown as {
  confirm: (options: SmartConfirmOptions) => SmartConfirmInstance
}

export function smartConfirm(options: SmartConfirmOptions) {
  return dialogPlugin.confirm(options)
}
